var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:[_vm.defaultClass, _vm.name, `${_vm.classPrefix}-${_vm.name}`, _vm.splitClass],style:({ fontSize: _vm.fontSizeVal, color: _vm.color, opacity: _vm.opacity }),on:{"click":_vm.handlerCallback,"mouseover":_vm.handlerMouseover,"mouseout":_vm.handlerMouseout}})
}
var staticRenderFns = []

export { render, staticRenderFns }